import { gql } from "@apollo/client"

export const CHECKOUT_COMPLETE = gql`
  mutation checkoutComplete($checkoutId: ID!, $paymentData: JSONString) {
    checkoutComplete(id: $checkoutId, paymentData: $paymentData) {
      order {
        id
        number
        metadata {
          key
          value
        }
        selectedRentalDate: metafield(key: "selectedRentalDate")
        lines {
          id
          quantity
          totalPrice {
            gross {
              amount
              currency
            }
          }
          variant {
            dataPackageGB: metafield(key: "dataPackageGB")
            rentalVariantSlug: metafield(key: "rentalVariantSlug")
            metadata {
              key
              value
            }
            pricing {
              price {
                currency
                gross {
                  amount
                  currency
                }
              }
            }
            product {
              category {
                name
              }
              description
              name
              media {
                url
              }
            }
            name
          }
        }
        deliveryMethod {
          ... on ShippingMethod {
            id
            name
            price {
              amount
              currency
            }
          }
        }
        subtotal {
          currency
          gross {
            amount
          }
        }
        shippingPrice {
          currency
          gross {
            amount
          }
        }
        undiscountedTotal {
          currency
          gross {
            amount
          }
        }
        total {
          gross {
            amount
            currency
          }
          tax {
            amount
          }
        }
        totalBalance {
          amount
        }
        paymentStatus
        status
      }
      confirmationNeeded
      confirmationData
      errors {
        field
        message
        code
      }
    }
  }
`
